import axiosInstance from '../config/axiosInstance';
import {useFormik} from 'formik';
import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'

function ServiceKeyEdit() {
    const params = useParams();
    const [isLoading, setLoading] = useState(false);
    const [domainList, setDomainList] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const navigate = useNavigate();

    const fetchDomainList = async () => {
        try {
            const response = await axiosInstance.get('/domains/list');
            const domains = response.data?.data || [];
            setDomainList(domains);
        } catch (error) {
            console.error('Error fetching domain list:', error);
            setDomainList([]);
        }
    };

    const fetchServiceList = async (domain) => {
        try {
            let serviceListResult = [];
            if (domain) {
                const response = await axiosInstance.get(`/domains/list?domain=${domain}`);
                serviceListResult = response.data?.data || [];
            } else {
                serviceListResult = domainList;
            }
            const mergedServiceList = serviceListResult.reduce((acc, domain) => {
                if (domain.service_code && Array.isArray(domain.service_code)) {
                    // Add unique services only
                    domain.service_code.forEach(service => {
                        if (!acc.includes(service)) {
                            acc.push(service);
                        }
                    });
                }
                return acc;
            }, []);
            setServiceList(mergedServiceList);
        } catch (error) {
            console.error('Error fetching service list:', error);
            setServiceList([]);
        }
    };

    const myFormik = useFormik({
        initialValues: {
            code: "",
            name: "",
            key: "",
            domain: ""
        },
        validate: (values) => {
            return {};
        },
        onSubmit: async (values) => {
            try {
                setLoading(true);
                const formData = new FormData();
                formData.append("code", values.code);
                formData.append("name", values.name);
                formData.append("key", values.key);
                formData.append("domain", values.domain);
                await axiosInstance.post(`/service-key/update/${params.id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                setLoading(false);
                navigate("/portal/service-key-list")
            } catch (error) {
                setLoading(false);
            }
        }
    });

    useEffect(() => {
        fetchDomainList();
        getConfigData().then(() => {})
    }, []);

    useEffect(() => {
        fetchServiceList(myFormik.values.domain);
    }, [myFormik.values.domain, domainList]);

    let getConfigData = async () => {
        try {
            const res = await axiosInstance.get(`/service-key/detail/${params.id}`);
            const config = res.data?.data ?? []
            if (!config) {
                navigate("/portal/service-key-list")
            } else {
                await myFormik.setValues(config);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            navigate("/portal/service-key-list")
        }
    }

    return (
        <>
            <h3>Service Key - Id : {params.id} </h3>
            <div className='container'>
                <form onSubmit={myFormik.handleSubmit}>
                    <div className='row'>
                        <div className="col-lg-6">
                            <label className='font-weight-bold'>Domain</label>
                            <select
                              name='domain'
                              value={myFormik.values.domain}
                              onChange={myFormik.handleChange}
                              className={`form-control ${myFormik.errors.domain ? "is-invalid" : ""}`}
                            >
                                <option value="">----Select Domain----</option>
                                {domainList.map((domain, index) => (
                                  <option key={index} value={domain.code}>{domain.code} ({domain.domain})</option>
                                ))}
                            </select>
                            <span style={{ color: "red" }}>{myFormik.errors.domain}</span>
                        </div>

                        <div className="col-lg-6">
                            <label className='font-weight-bold'>Code</label>
                            <select
                              name='code'
                              value={myFormik.values.code}
                              onChange={myFormik.handleChange}
                              className={`form-control ${myFormik.errors.code ? "is-invalid" : ""}`}
                            >
                                <option value="">----Select----</option>
                                {serviceList.map((service, index) => (
                                  <option key={index} value={service}>{service}</option>
                                ))}
                            </select>
                            <span style={{ color: "red" }}>{myFormik.errors.code}</span>
                        </div>

                        <div className="col-lg-6">
                            <label className='font-weight-bold'>Name</label>
                            <input
                              name='name'
                              value={myFormik.values.name}
                              onChange={myFormik.handleChange}
                              type="text"
                              className={`form-control ${myFormik.errors.name ? "is-invalid" : ""}`}
                            />
                            <span style={{ color: "red" }}>{myFormik.errors.name}</span>
                        </div>

                        <div className="col-lg-6">
                            <label className='font-weight-bold'>API Key</label>
                            <input
                              name='key'
                              value={myFormik.values.key}
                              onChange={myFormik.handleChange}
                              type="text"
                              className={`form-control ${myFormik.errors.key ? "is-invalid" : ""}`}
                            />
                            <span style={{ color: "red" }}>{myFormik.errors.key}</span>
                        </div>

                        <div className='col-lg-12 mt-3'>
                            <input
                              disabled={isLoading}
                              type="submit"
                              value={isLoading ? "Submitting..." : "Save"}
                              className='btn btn-primary'
                            />
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default ServiceKeyEdit;